<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Промокоды</strong>
                </CCardHeader>
                <CCardBody>
                    <CustomerTabLinks />
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <div v-show="!loading">
                        <PromocodesTable
                            class="mt-4"
                            :list="list"
                            @select="(id) => $router.push(`/promocodes/${id}`)"
                        />
                        <CPagination
                            v-if="total > 1"
                            class="mt-4"
                            :active-page.sync="activePage"
                            :pages="total"
                            align="center"
                        />
                    </div>
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="$router.push(`promocodes/customer-promocode-create`)"
                    >Создать</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import PromocodesTable from '@/components/promocodes/PromocodesTable';
    import CustomerTabLinks from '@/components/CustomerTabLinks';
    import { ITEMS_PER_PAGE } from '@/utils/views';

    export default {
        name: 'PromocodesList',

        components: {
            PromocodesTable,
            CustomerTabLinks,
        },

        data() {
            return {
                loading: true,
                list: [],
                total: 0,
                itemsPerPage: ITEMS_PER_PAGE,
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                },
            },
        },

        watch: {
            activePage: 'fetchList',
        },

        async created() {
            await Promise.all([this.fetchList()]);
        },

        methods: {
            async fetchList() {
                this.loading = true;
                const id = this.$route.params.id;
                const params = { page: this.activePage, pageSize: this.itemsPerPage };
                const response = await this.axios.get(`/promocodes/customer/${id}`, { params });
                this.list = response.data.results;
                this.total = Math.ceil(response.data.total / this.itemsPerPage);
                this.loading = false;
            },
        },
    };
</script>
